import { useState, ReactNode, useEffect } from 'react'
import '../Controller/Controller.css'
import { motion } from "motion/react"
import emitMessage from '../socket';
import { socket } from '../socket';
import { useLocation } from 'react-router-dom';


export default function Controller(): ReactNode {
    const { pathname } = useLocation();
    const playerNumber = pathname.replace("/player", "");
    const [ready, setReady] = useState<boolean>(false);
    const [globalReady, setGlobalReady] = useState<boolean>(false); // Change to false when testing finished

    // Set up socket listener only once when component mounts
    useEffect(() => {
        socket.on('messageToBrowser', (data: any) => {
            console.log('Message from Unity (function):', data);
            if (data.content === "APR" && data.teamHash === 'meme') {
                setGlobalReady(true);
            }
            else if (data.content === "APROVERWRITE") {
                setGlobalReady(true);
            }
        });

        // Cleanup: remove listener when component unmounts
        return () => {
            socket.off('messageToBrowser');
        };
    }, []);

    // Conditionally renders ready screen
    function ReadyState(): ReactNode {
        if (!globalReady) {
            return (
                <div className="ready-cover">
                    <p> YOU ARE:</p>
                    <motion.button type="button" onClick={toggleReady} whileTap={{ scale: 1.1 }} className="ready-button"> {ready ? "READY" : "NOT READY"} </motion.button>
                </div>
            );
        }
    }
    // toggles ready state per player
    function toggleReady(): void {
        const nextReady = !ready;
        setReady(nextReady);
        emitMessage(`${nextReady ? "RU" : "NotReady"}${playerNumber}`);
    }


    console.log(`Player ${playerNumber} connected successfully`);
    if (pathname === "/player1") {
        console.log("Player 1 connected");
    } else if (pathname === "/player2") {
        console.log("Player 2 connected");
    } else if (pathname === "/player3") {
        console.log("Player 3 connected");
    }

    console.log(ready);
    return (
        <div className="App">
            <div className="ContentContainer">
                <div className="controller-container">
                    <div className="movement-container">
                        <motion.div
                            onClick={() => emitMessage(`U${playerNumber}`)}
                            whileTap={{ scale: 0.92 }}
                            id="ForwardBtn"
                            className="BtnFB"
                        >
                            <svg viewBox="0 0 24 24" className="arrow-img"><path d="M12 4l8 10H4z" fill="white" /></svg>
                        </motion.div>

                        <motion.div
                            onClick={() => emitMessage(`D${playerNumber}`)}
                            whileTap={{ scale: 0.92 }}
                            id="BackBtn"
                            className="BtnFB"
                        >
                            <svg viewBox="0 0 24 24" className="arrow-img"><path d="M12 20L4 10h16z" fill="white" /></svg>
                        </motion.div>

                        <motion.div
                            onClick={() => emitMessage(`L${playerNumber}`)}
                            whileTap={{ scale: 0.92 }}
                            id="LeftBtn"
                            className="BtnLR"
                        >
                            <svg viewBox="0 0 24 24" className="arrow-img"><path d="M4 12l10-8v16z" fill="white" /></svg>
                        </motion.div>

                        <motion.div
                            onClick={() => emitMessage(`R${playerNumber}`)}
                            whileTap={{ scale: 0.92 }}
                            id="RightBtn"
                            className="BtnLR"
                        >
                            <svg viewBox="0 0 24 24" className="arrow-img"><path d="M20 12L10 4v16z" fill="white" /></svg>
                        </motion.div>
                    </div>

                    <motion.div
                        onClick={() => emitMessage(`I${playerNumber}`)}
                        whileTap={{ scale: 0.92 }}
                        id="InteractBtn"
                        className="BtnInteract"
                    >
                        <svg viewBox="0 0 24 24" className="interact-icon">
                            <path d="M13 2L4.5 13.5H11L10 22l9.5-12H13z" fill="white" />
                        </svg>
                        <span className="interact-label">interact</span>
                    </motion.div>

                </div>
            </div>
            {ReadyState()}
        </div>
    )
}
